import { render, staticRenderFns } from "./AutomaticSettlementlist.vue?vue&type=template&id=3f22570e"
import script from "./AutomaticSettlementlist.vue?vue&type=script&lang=ts"
export * from "./AutomaticSettlementlist.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports